// extracted by mini-css-extract-plugin
export default {"bar":"ModalNotifications_bar__VYGdD","show":"ModalNotifications_show__0XZF7"};